import type { ChatbotDto } from "@virtual-brain-lib/frontend-api";
import type { ChatMessage } from "@virtual-brain-lib/types";

export const INITIAL_MESSAGE_ID = "initial-message";

function createChatbotInitialMessage(chatbot: ChatbotDto): ChatMessage {
	return {
		id: INITIAL_MESSAGE_ID,
		role: "assistant",
		content: chatbot.initialMessage,
		isFollowUp: false,
		webMode: "auto",
		suggestedPrompts: chatbot.initialQuestions,
		createdAt: new Date(),
	};
}

export function prependChatbotInitialMessage(
	messages: ChatMessage[],
	chatbot: ChatbotDto,
): ChatMessage[] {
	return messages[0]?.id === INITIAL_MESSAGE_ID
		? messages
		: [createChatbotInitialMessage(chatbot), ...messages];
}
